// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutMain_root__4_Z7y"};